import { render, staticRenderFns } from "./conflictCase.vue?vue&type=template&id=c4abc022&scoped=true&"
import script from "./conflictCase.vue?vue&type=script&lang=js&"
export * from "./conflictCase.vue?vue&type=script&lang=js&"
import style0 from "./conflictCase.vue?vue&type=style&index=0&id=c4abc022&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4abc022",
  null
  
)

export default component.exports